/* eslint-disable */
/// This file is auto generated - do not edit manually
export const StandardPoints = 'Website.Points.StandardPoints';
export const MatasPlusPoints = 'Website.Points.MatasPlusPoints';
export const ExtraStorePoints = 'Website.Points.ExtraStorePoints';
